<div class="playback-settings">

  @if (playbackStatus === PlaybackStatus.LOADING) {
    <mat-spinner [diameter]="52"></mat-spinner>
  }
  @if (playbackStatus === PlaybackStatus.STOPPED) {
    <button mat-button
            class="playback-button"
            (click)="actionTriggered(PlaybackAction.PLAY)"
    >
      <mat-icon class="filled-icon">play_arrow</mat-icon>
    </button>
  } @else if (playbackStatus === PlaybackStatus.PLAYING) {
    <button mat-button
            class="playback-button"
            (click)="actionTriggered(PlaybackAction.STOP)"
    >
      <mat-icon class="filled-icon">pause</mat-icon>
    </button>
  }

  <div>
    <button
      mat-button
      class="speed-button"
      [matMenuTriggerFor]="menu"
      [disabled]="playbackStatus === PlaybackStatus.PLAYING"
    >
      <span>{{ speed }}x</span>
    </button>

    <mat-menu #menu="matMenu" class="speed__menu">
      @for (speed of speeds; track $index) {
        <button mat-menu-item (click)="onSpeedChanged(speed)">{{ speed }}x</button>
      }
    </mat-menu>
  </div>

</div>

<div class="timeline-wrapper">
  <div class="timeline-row">
    <div class="timeline-label">
    </div>
    <div class="timeline-bar-wrapper">
      <div class="timeline-duration">
        <div class="timeline-marker"
             [ngStyle]="{ 'left.px': markerPositionPx, 'height.px': 18 }"
             (mousedown)="onMarkerMouseDown($event)"
             [class.dragging]="isDragging"
        >
          <span class="timeline-marker-label"
                [style.right.px]="markerFromEndPx < 20 ? -markerFromEndPx + 5 : null"
                [style.left]="markerLabelLeft"
          >{{ currentTimestamp | date:'hh:mm:ss' }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="timeline-row">
    <div class="timeline-label">

    </div>
    <div class="timeline-bar-wrapper">
      <div class="timeline-axis">
        <div class="timeline-axis-label-bar" (click)="onTimeLineClick($event)" #timeLineBar>
          @for (marker of timeAxisMarkers; track $index) {
            <div
              class="axis-marker-wrapper"
              [style.left.%]="marker.position"
            >
              <div
                class="axis-marker"
                [style.transform]="marker.isEnd ? 'translateX(-1px)': 'translateX(0)'"
              ></div>

              <div
                class="axis-label"
                [style.transform]="marker.isEnd ? 'translateX(-100%)': 'translateX(0)'"
                [style.background-color]="marker.isStart !== undefined || marker.isEnd !== undefined ? 'white': undefined"
              >
                {{ marker.label }}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
